import * as React from 'react';

import { Content, TextField } from '@rematter/ui-web';
import { useAtomValue, useSetAtom } from 'jotai';

import {
  $agentDetailForm,
  $updateAgentDetailForm,
} from '../../_state/agentDetail.state';
import { useTranslations } from '../../i18n/useTranslations';

export const AgentTabPrompt = () => {
  const t = useTranslations();
  const formData = useAtomValue($agentDetailForm);
  const updateFormData = useSetAtom($updateAgentDetailForm);

  return (
    <Content className="@AgentTabPrompt h-full p-4">
      <div className="flex h-full flex-col">
        <TextField
          label={t.aiManagement.agents.details.fields.content.label}
          placeholder={t.aiManagement.agents.details.fields.content.placeholder}
          description={t.aiManagement.agents.details.fields.content.description}
          value={formData.content}
          onChange={(value) => updateFormData({ content: value })}
          rows={28}
          className="[&_textarea]:font-mono"
        />
      </div>
    </Content>
  );
};
